import { render, staticRenderFns } from "./exchange-goods-panel.vue?vue&type=template&id=6e6032f3&scoped=true&lang=pug&"
import script from "./exchange-goods-panel.vue?vue&type=script&lang=js&"
export * from "./exchange-goods-panel.vue?vue&type=script&lang=js&"
import style0 from "./exchange-goods-panel.vue?vue&type=style&index=0&id=6e6032f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6032f3",
  null
  
)

export default component.exports